
import $ from 'jquery';
import twitterFetcher from 'twitter-fetcher';

export default class Twitter {
  constructor($el) {
    this.$tweetContainer = null;
    this.$tweetContainer = $el.find('[data-twitter-tweets]');
    const username = $el.find('[data-twitter-username]').attr('data-twitter-username');
    const retweets = $el.find('[data-show-retweets]').length;

    this._fetchTweets(username, retweets);
  }

  _fetchTweets(username, retweets) {
    const config = {
      profile: { screenName: username },
      maxTweets: 1,
      enableLinks: true,
      showUser: true,
      showTime: true,
      useEmoji: true,
      showRetweet: retweets,
      customCallback: tweets => this.renderTweets(tweets),
      showInteraction: false,
    };

    twitterFetcher.fetch(config);
  }

  renderTweets(tweets) {
    this.$tweetContainer.html();

    if (tweets.length) {
      this.$tweetContainer.html($(tweets[0]));
    } else {
      console.log('No tweets to display. Most probable cause is an incorrectly entered username.');
    }
  }
}
